import { render, staticRenderFns } from "./Affirmations.vue?vue&type=template&id=7d79038d&scoped=true&"
import script from "./Affirmations.vue?vue&type=script&lang=js&"
export * from "./Affirmations.vue?vue&type=script&lang=js&"
import style0 from "./Affirmations.vue?vue&type=style&index=0&id=7d79038d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d79038d",
  null
  
)

export default component.exports